<template>
    <b-row>
        <Sidebar/>
        <b-col md="10" offset-md="2">
            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2">Usuarios</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <b-button variant="outline-secondary" to="/usuarios/nuevo">Nuevo</b-button>
                    </div>
                </div>
            </div>
            <p v-if="isLoading">Cargando...</p>
            <b-table v-else hover v-bind:items="rows" v-bind:fields="headers" outlined
                     head-variant="light">
                <template slot="id" slot-scope="data">
                    <b-link v-bind:to="'/usuarios/' + data.item.id">{{data.item.id}}</b-link>
                </template>
                <template slot="actions" slot-scope="data">
                    <div class="btn-group">
                        <b-button variant="outline-secondary" size="sm" v-bind:to="'/usuarios/' + data.item.id">Ver</b-button>
                        <b-button variant="outline-secondary" size="sm" v-bind:to="'/usuarios/editar/' + data.item.id">Editar</b-button>
                    </div>
                </template>

            </b-table>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "Users",
        data() {
            return {
                isLoading: true,
                headers: [
                    {key: 'id', label: 'ID', sortable: true},
                    {key: 'username', label: 'Usuario', sortable: true},
                    {key: 'name', label: 'Nombre', sortable: true},
                    {key: 'email', label: 'Email', sortable: true},
                    {key: 'rut', label: 'RUT', sortable: true},
                    {key: 'rol', label: 'Rol', sortable: true},
                    {key: 'actions', label: 'Acciones', sortable: false},
                ]
            }
        },
        computed: {
            ...mapGetters('users', {
                rows: 'getUsers'
            })
        },
        created() {
            this.$store.dispatch('users/loadUsers').then(() => {
                this.isLoading = false;
            });
        }
    }
</script>